import { useEffect, useState } from "react";

/**
 * Character-by-character reveal at ~33 chars/sec by default. Respects
 * prefers-reduced-motion — reduced-motion users see the full text instantly.
 * Interval always cleared on unmount / text change.
 */
export function useTypewriter(text, { charsPerSecond = 33, onComplete } = {}) {
  const [display, setDisplay] = useState("");
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    setDisplay("");
    setIsComplete(false);
    if (!text) {
      setIsComplete(true);
      return undefined;
    }
    const reducedMotion =
      typeof window !== "undefined" &&
      window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    if (reducedMotion) {
      setDisplay(text);
      setIsComplete(true);
      onComplete?.();
      return undefined;
    }
    let i = 0;
    const iv = setInterval(() => {
      i += 1;
      setDisplay(text.slice(0, i));
      if (i >= text.length) {
        clearInterval(iv);
        setIsComplete(true);
        onComplete?.();
      }
    }, 1000 / charsPerSecond);
    return () => clearInterval(iv);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, charsPerSecond]);

  return { display, isComplete };
}
